import { AlertController, NavController, NavParams } from 'ionic-angular';
import { Api } from '../../../../../providers/api';
import { BookingGroup } from '../../../../../entities/booking-group';
import { BookingThankYouPage } from '../booking-thank-you/booking-thank-you';
import { BookSailingInterface, NewBookingInterface } from '../../../../../interfaces/api';
import { Component } from '@angular/core';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';

@Component({
    selector: 'page-place-booking',
    templateUrl: 'place-booking.html',
})
export class PlaceBookingPage {

    bookings: BookingGroup;

    constructor(
        private api: Api,
        private navCtrl: NavController,
        private navParams: NavParams,
        private spinner: SpinnerDialog,
        private alertCtrl: AlertController,
    ) {
        this.bookings = this.navParams.get('bookings');
    }

    async placeBooking() {
        this.spinner.show();
        let bookingResponse = await this.api.postNewBookings(this.prepareBookingForApi());
        if (bookingResponse) {
            this.navCtrl.push(BookingThankYouPage);
        } else {
            let prompt = this.alertCtrl.create({
                title: 'Booking not placed',
                subTitle: 'Check your details and try again',
                buttons: ['Dismiss']
            });
            prompt.present();
        }
        this.spinner.hide();
    }

    prepareBookingForApi(): NewBookingInterface {
        let booking: NewBookingInterface = {
            outbound: this.prepareSailing('outbound_booking', this.bookings.outbound_sailing.id)
        };
        if (this.bookings.is_return_journey)
            booking.inbound = this.prepareSailing('return_booking', this.bookings.return_sailing.id);
        return booking;
    }

    prepareSailing(booking_ref: string, sailing_id: number): BookSailingInterface {
        return {
            date: this.bookings[booking_ref].departing_at.format('YYYY-MM-DD'),
            sailing_id: sailing_id,
            vehicle: this.bookings.vehicle,
            loaded: this.bookings.loaded,
            live_stock: this.bookings.live_stock,
            hazardous: this.bookings.hazardous,
            plug_in: this.bookings.plug_in,
            main_deck: this.bookings.main_deck,
            drivers: this.bookings.drivers,
            contact_name: this.bookings.contact_name,
            contact_number: this.bookings.contact_number,
            notes: this.bookings.notes,
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/bookings/my-bookings/create-booking/place-booking/place-booking.ts